var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardHeader, CardFooter, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import GetOrganisationFeedsCommand from '../../../commands/organisations/GetOrganisationFeedsCommand';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import FeedRow from "./FeedRow";
/**
 *
 */
var Feeds = /** @class */ (function (_super) {
    __extends(Feeds, _super);
    /**
     *
     */
    function Feeds(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     */
    Feeds.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    Feeds.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    Feeds.prototype.initialize = function () {
        var _a = this.context, session = _a.session, feedCollection = _a.feedCollection;
        var user = session.user;
        var command = new GetOrganisationFeedsCommand();
        command.execute(user, feedCollection);
    };
    /**
     *
     * @returns {*}
     */
    Feeds.prototype.render = function () {
        var intl = this.props.intl;
        var _a = this.context, session = _a.session, feedCollection = _a.feedCollection;
        console.log(feedCollection);
        if (!this.context.session.isLoggedIn) {
            return null;
        }
        return (React.createElement(Page, { pageName: "feeds" },
            React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                React.createElement(CardHeader, { className: "flex-grow-0" },
                    React.createElement("h1", { className: "card-header-title" },
                        React.createElement(FormattedMessage, { id: "page.feeds.title" }))),
                React.createElement(CardBody, { className: "pt-0 mr-4 pr-0 overflow-auto" },
                    React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                        React.createElement("div", { className: "w-100", style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 2fr 2fr 5fr" + (session.user.isOwner ? " 2fr" : ""),
                                rowGap: "1.3rem",
                                minWidth: "fit-content"
                            } },
                            React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                React.createElement("div", null,
                                    React.createElement(FormattedMessage, { id: "page.feeds.table.column.status" })),
                                React.createElement("div", null,
                                    React.createElement(FormattedMessage, { id: "page.feeds.table.column.provider" })),
                                React.createElement("div", null,
                                    React.createElement(FormattedMessage, { id: "page.feeds.table.column.type" })),
                                React.createElement("div", null,
                                    React.createElement(FormattedMessage, { id: "page.feeds.table.column.lastprocessed" })),
                                session.user.isOwner ?
                                    React.createElement("div", null)
                                    : null),
                            feedCollection.filtered.length > 0 ?
                                feedCollection.filteredAndSorted.map(function (feedModel, index) {
                                    return React.createElement(FeedRow, { key: 'feed-' + feedModel.id, feedModel: feedModel });
                                }) : React.createElement(EmptyDivRow, null)))),
                React.createElement(CardFooter, null,
                    React.createElement("div", { className: "d-flex justify-content-end" }, session.user.isOwner ?
                        React.createElement(Link, { to: Routes.FEEDS_ADD.getPath() },
                            React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                React.createElement("span", { className: "fe fe-plus" }),
                                React.createElement(FormattedMessage, { id: "page.feeds.addfeed" }))) : null)))));
    };
    Feeds = __decorate([
        observer
    ], Feeds);
    return Feeds;
}(React.Component));
Feeds.contextType = ApplicationContext;
export default injectIntl(Feeds);
